import { render } from "./Kontak.vue?vue&type=template&id=8d40ae08&scoped=true"
import script from "./Kontak.vue?vue&type=script&lang=js"
export * from "./Kontak.vue?vue&type=script&lang=js"

import "./Kontak.vue?vue&type=style&index=0&id=8d40ae08&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d40ae08"]])

export default __exports__